<app-view-dashboard-component>
  <div modalTitle>
    <div slot="start"
      class="logo">
      <img src="./assets/images/logo.png" />
    </div>
  </div>
  <h4>{{ 'partner.other' | translate }}</h4>
  <ion-item lines="none"
    button="true"
    (click)="onOffers()">
    <ion-icon slot="start"
      name="file-tray-stacked-outline"></ion-icon>
    {{ 'partner.ownOffers' | translate }}
  </ion-item>
  <ion-item lines="none"
    button="true"
    (click)="onContracts()">
    <ion-icon slot="start"
      name="file-tray-full-outline"></ion-icon>
    {{ 'partner.ownContracts' | translate }}
  </ion-item>
</app-view-dashboard-component>